module.exports = __webpack_public_path__ + "img/mh.307c6eb0.svg";